import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Star } from "lucide-react";
import { SITE } from "../lib/site";

const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=240x240&color=C5A059&bgcolor=0A0A0A&margin=10&data=${encodeURIComponent(
  SITE.googleReviewUrl
)}`;

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#050505] pt-20 pb-10 border-t border-white/5 overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-10 left-0 right-0 text-center font-display text-[18vw] leading-none tracking-tighter"
        style={{ color: "rgba(255,255,255,0.025)" }}
      >
        ZELAYA'S
      </div>

      <div className="container-luxury relative">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <Link to="/" className="font-display text-3xl text-white">
              Zelaya<span style={{ color: "var(--gold)" }}>'</span>s Design INC
            </Link>
            <p className="mt-4 text-white/60 max-w-md leading-relaxed">
              Owned by <span className="text-white">{SITE.owner}</span>. {SITE.yearsExperience} years
              delivering premium painting, stucco, and remodeling craftsmanship across Wesley Chapel
              and surrounding areas — backed by a {SITE.warranty}.
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              <a href={SITE.phoneHref} className="btn-primary !py-3 !px-5" data-testid="footer-call-btn">
                <Phone size={16} /> Call Now
              </a>
              <Link to="/contact" className="btn-secondary !py-3 !px-5" data-testid="footer-estimate-btn">
                Free Estimate
              </Link>
            </div>

            <div className="mt-8 flex items-center gap-4">
              <a href="#" aria-label="Facebook" className="text-white/60 hover:text-[var(--gold)] transition-colors" data-testid="footer-facebook"><Facebook size={20} /></a>
              <a href="#" aria-label="Instagram" className="text-white/60 hover:text-[var(--gold)] transition-colors" data-testid="footer-instagram"><Instagram size={20} /></a>
              <a href={SITE.googleReviewUrl} target="_blank" rel="noopener noreferrer" aria-label="Google Reviews" className="text-white/60 hover:text-[var(--gold)] transition-colors" data-testid="footer-google"><Star size={20} /></a>
            </div>
          </div>

          <div>
            <p className="overline mb-5">Contact</p>
            <ul className="space-y-4 text-white/70">
              <li className="flex items-start gap-3"><Phone size={16} className="mt-1 text-[var(--gold)]" /> <a href={SITE.phoneHref} className="hover:text-white">{SITE.phone}</a></li>
              <li className="flex items-start gap-3"><Mail size={16} className="mt-1 text-[var(--gold)]" /> <a href={SITE.emailHref} className="hover:text-white break-all">{SITE.email}</a></li>
              <li className="flex items-start gap-3"><MapPin size={16} className="mt-1 text-[var(--gold)]" /> <span>{SITE.address}</span></li>
            </ul>
          </div>

          <div>
            <p className="overline mb-5">Leave a Review</p>
            <a href={SITE.googleReviewUrl} target="_blank" rel="noopener noreferrer" className="inline-block border border-white/10 p-2 bg-[#0A0A0A] hover:border-[var(--gold)] transition-colors" data-testid="footer-qr">
              <img src={qrSrc} alt="Scan to leave a Google review" className="w-32 h-32 object-cover" />
            </a>
            <p className="mt-3 text-xs text-white/50">Scan to leave a Google review</p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-white/40 uppercase tracking-[0.2em]">
            © {new Date().getFullYear()} Zelaya's Design INC — All rights reserved
          </div>
          <div className="flex gap-6 text-xs text-white/40 uppercase tracking-[0.2em]">
            <span>{SITE.yearsExperience} Years Experience</span>
            <span>{SITE.warranty}</span>
            <Link to="/admin" className="hover:text-white/70" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
